export default __webpack_public_path__ + "static/media/banner3.39c0d072.jpg";